<template>

    <fragment >
      <text  :transform="indicator.transform" class="st1 st2" :class="[indicator.status == true ? activeClass :  desactiveClass,indicator.class ?indicator.class :'' ]">
        {{indicator.text}}
      </text>
     <!--  <circle  :cx="indicator.cxB" :cy="indicator.cyB" :r="indicator.rB" :class="[indicator.status == true ? activeClass :  desactiveClass]"/>
      <circle   class="st0" :cx="indicator.cxW" :cy="indicator.cyW" :r="indicator.rW" :class="[indicator.status == true ? activeClass :  desactiveClass]"/> -->
      <line    class="st3 torreai" :x1="indicator.x1" :y1="indicator.y1" :x2="indicator.x2" :y2="indicator.y2" :class="[indicator.status == true ? activeClass :  desactiveClass]"/>
    </fragment>
   
   
   
   </template>
   <script>
   
   
   export default {
     name: "Indicators",
     data() {
       return{
         activeClass: 'aparece',
         desactiveClass: 'desaparece',
         textIndicator: ""
       }
     },
     props: ["indicator"],
     computed: {
     },
     methods: {
   
     },
     mounted() {
     
     }
   }
   </script>
   <style scoped>
   .st3.torreai{
    stroke-width:2
   }
   </style>